// A client-side copy of the command-and-control (C2) transmission delay formula from src/sim/orders.ts,
// so an order card can show what a card will cost in transmission time *before* it is played. The sim
// stays the authority: this is an estimate on the card, never an input to the simulation.

import type { Dials, Unit } from '../../sim/types';
import { TICK_SEC, TICKS_PER_MIN } from '../../sim/types';

/** Company-sized ground maneuver units take twice as long to raise as enablers on the same net. */
const COMPANY_TYPES: ReadonlySet<Unit['type']> = new Set(['armor', 'mech', 'inf', 'recon']);

/**
 * Estimated seconds between the order leaving the command net and the unit receiving it. Mirrors
 * `delayTicks` in src/sim/orders.ts; if that formula changes, this must change with it.
 */
export function transmitEstimateSec(dials: Dials, unit: Unit | null, hqAlive: boolean): number {
  if (!unit || dials.c2 === 'off') return 0;
  let minutes = COMPANY_TYPES.has(unit.type) ? 4 : 2;
  minutes *= dials.ew === 'none' ? 1 : dials.ew === 'moderate' ? 1.5 : 2.5;
  if (unit.inContact) minutes *= 1.5;
  if (!hqAlive) minutes *= 2;
  if (dials.c2 === 'degraded') minutes *= 2;
  return Math.round(minutes * TICKS_PER_MIN) * TICK_SEC;
}
